import type { IconProps } from './types';

export const WalmartCircleIcon = (props: IconProps) => {
  const { size = 20, ref, color = 'currentColor', ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        fill={color}
        d="M12.4521 9.41281C13.1073 9.41281 13.6465 9.07203 13.7193 8.63203L14.3665 1.3168C14.3665 0.593594 13.5201 0 12.4545 0C11.3905 0 10.5449 0.593594 10.5449 1.3168L11.1905 8.63203C11.2625 9.07203 11.8017 9.41281 12.4545 9.41281H12.4521Z"
      />
      <path
        d="M8.49759 11.698C8.82639 11.1316 8.8008 10.494 8.45523 10.2116L2.44243 5.99403C1.81759 5.63243 0.879995 6.06841 0.347993 6.99083C-0.18561 7.91161 -0.0912061 8.94122 0.532788 9.30282L7.18959 12.4028C7.60639 12.5572 8.17359 12.2604 8.5 11.694L8.49759 11.698Z"
        fill={color}
      />
      <path
        d="M16.4084 11.694C16.7364 12.2604 17.3012 12.5572 17.718 12.4028L24.3756 9.30282C25.0028 8.94121 25.0924 7.91164 24.5628 6.99082C24.0284 6.06844 23.0892 5.63242 22.466 5.99403L16.4532 10.2116C16.1092 10.494 16.0836 11.1316 16.4109 11.698L16.4084 11.694Z"
        fill={color}
      />
      <path
        d="M12.4521 18.5488C13.1073 18.5488 13.6465 18.8872 13.7193 19.3272L14.3665 26.6416C14.3665 27.3664 13.5201 27.9592 12.4545 27.9592C11.3905 27.9592 10.5449 27.3664 10.5449 26.6416L11.1905 19.3272C11.2625 18.8872 11.8017 18.5488 12.4545 18.5488H12.4521Z"
        fill={color}
      />
      <path
        d="M16.4084 16.2645C16.7364 15.6973 17.3012 15.4021 17.718 15.5589L24.3756 18.6557C25.0028 19.0181 25.0924 20.0484 24.5628 20.9709C24.0284 21.89 23.0892 22.3268 22.466 21.9661L16.4532 17.7525C16.1092 17.4668 16.0836 16.8293 16.4109 16.2637L16.4084 16.2645Z"
        fill={color}
      />
      <path
        d="M8.49759 16.2637C8.82639 16.8293 8.80079 17.4669 8.45522 17.7525L2.44242 21.9661C1.81762 22.3269 0.88002 21.8901 0.348018 20.9709C-0.185615 20.0485 -0.0912114 19.0181 0.532783 18.6557L7.18959 15.5589C7.60639 15.4021 8.17358 15.6973 8.49999 16.2645L8.49759 16.2637Z"
        fill={color}
      />
    </svg>
  );
};
